import { registerApi as api } from '../../api';

export const fetchAttendanceRegister = async (current_month) => {
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const data = {
            client_id:client_ID
        }
        const response = await api.post(`/attendance_register_get/${current_month}`, data,{
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error.message;
    }
}

export const regenerateAttendanceRegister = async (current_month) => {
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const data = {
            client_id:client_ID
        }
        const response = await api.post(`/regenerate_attendance_register/${current_month}`, data,{
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error.message;
    }
}

export const fetchgenerateAttendanceRegister = async (current_month) => {
    const month = String(current_month || "").trim();
    if (!/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(month) || month.includes("NaN")) {
        throw "A valid payroll month is required (YYYY-MM-DD).";
    }
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const response = await api.get(`/get_generate_attendance_register/${month}`, {
            params: {
                client_id: client_ID
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error.message;
    }
}


export const downloadAttendanceRegister = async (data) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post(`/download_attendance_register_selected`, data, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'attendance_register.xlsx');
        document.body.appendChild(link)
            ;
        link.click();
        link.remove();
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const downloadAllAttendanceRegister = async (data) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post(`/download_attendance_register_all`, data, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'attendance_register.xlsx');
        document.body.appendChild(link)
            ;
        link.click();
        link.remove();
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}


export const deleteSingleAttendanceRecord = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_single_attendance_register/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};



export const multipleDeleteAttendanceRegister = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multiple_attendance_register', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
